export default __webpack_public_path__ + "assets/images/389cbb349c805168fc796215dafb4a7f.jpeg";